import type { ReactNode } from 'react'
import { ChevronDown, ChevronUp } from 'baseui/icon'
import PulseCollapse from '@/shared/components/PulseScope/PulseCollapse'
import { PanelBlock, PanelChevron, PanelContent, PanelHeader, PanelHeaderTitle } from './styled-components'

interface SalePanelCollapseProps {
  id: string
  open: boolean
  onToggle: () => void
  title: ReactNode
  compact?: boolean
  last: boolean
  children: ReactNode
}

const SalePanelCollapse = ({ id, open, onToggle, title, compact = false, last, children }: SalePanelCollapseProps) => (
  <PanelBlock $last={last}>
    <PanelHeader
      type='button'
      id={`${id}-header`}
      aria-expanded={open}
      aria-controls={`${id}-content`}
      $compact={compact}
      $open={open}
      onClick={onToggle}
    >
      <PanelHeaderTitle>{title}</PanelHeaderTitle>
      <PanelChevron aria-hidden='true'>
        {open ? <ChevronUp size={20} color='currentColor' /> : <ChevronDown size={20} color='currentColor' />}
      </PanelChevron>
    </PanelHeader>
    <PulseCollapse open={open} scrollOnOpen={false}>
      <PanelContent id={`${id}-content`} role='region' aria-labelledby={`${id}-header`} $compact={compact}>
        {children}
      </PanelContent>
    </PulseCollapse>
  </PanelBlock>
)

export default SalePanelCollapse
